/**
 * Utility functions para normalizar dados recebidos das APIs Sponte
 * Implementa defensive programming para garantir que sempre trabalhamos
 * com estruturas de dados válidas, independente do formato recebido
 */

/**
 * Normaliza dados de estudantes de uma turma
 * Aceita tanto array direto quanto objeto com propriedade Integrantes
 * Sempre retorna um array de estudantes válidos
 */
export function normalizeStudentsByClassroom(data) {
  if (!data) {
    return [];
  }

  // Se for array direto (novo formato)
  if (Array.isArray(data)) {
    return data.filter(student => student && student.AlunoID);
  }

  // Se for objeto com propriedade Integrantes (formato legado)
  if (data.Integrantes) {
    const integrantes = Array.isArray(data.Integrantes) 
      ? data.Integrantes 
      : [data.Integrantes];
    return integrantes.filter(student => student && student.AlunoID);
  }

  // Se for um único objeto (não array)
  if (data.AlunoID) {
    return [data];
  }

  return [];
}

/**
 * Normaliza dados de disciplinas
 * Sempre retorna um array de disciplinas válidas
 */
export function normalizeSubjects(data) {
  if (!data) {
    return [];
  }

  // Se for array direto
  if (Array.isArray(data)) {
    return data.filter(subject => subject && (subject.DisciplinaID || subject.id));
  }

  // Se for objeto com propriedade Disciplinas (formato legado)
  if (data.Disciplinas) {
    const disciplinas = Array.isArray(data.Disciplinas)
      ? data.Disciplinas
      : [data.Disciplinas];
    return disciplinas.filter(subject => subject && (subject.DisciplinaID || subject.id));
  }

  // Se for um único objeto
  if (data.DisciplinaID || data.id) {
    return [data];
  }

  return [];
}

/**
 * Normaliza dados de turmas
 * Sempre retorna um array de turmas válidas
 */
export function normalizeClassrooms(data) {
  if (!data) {
    return [];
  }

  if (Array.isArray(data)) {
    return data.filter(classroom => classroom && classroom.TurmaID);
  }

  if (data.TurmaID) {
    return [data];
  }

  return [];
}

/**
 * Garante que um valor seja sempre um array
 * Útil para proteção defensiva em componentes
 */
export function ensureArray(value) {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}

/**
 * Garante que um valor seja sempre um número ou null
 */
export function ensureNumber(value) {
  if (value === null || value === undefined) {
    return null;
  }
  const num = Number(value);
  return isNaN(num) ? null : num;
}

/**
 * Garante que um valor seja sempre uma string ou vazia
 */
export function ensureString(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}















